<div class="nav-container">

    <nav id="main-menu-navigation" class="navigation-main">
      
        <div class="nav-item " routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <a [routerLink]="['/auth']"  ngbTooltip="{{'menu.Home' | translate}}"><img src="assets/images/Home-menu.png" class="img-fluid" alt="SEU"><span>{{'menu.Home' | translate}}</span></a>
        </div>

        <!--  <div class="nav-item "  >
            <a [routerLink]="['/auth']"  ngbTooltip="{{'menu.prof' | translate}}"><img src="assets/images/employee.png" class="img-fluid" alt="SEU"><span>{{'menu.prof' | translate}}</span></a>
    </div>-->
        <div class="nav-item " routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <a [routerLink]="['/auth/patient/majors']"  ngbTooltip="{{'menu.major' | translate}}"> <img src="assets/images/clinics-menu.png" class="img-fluid" alt="SEU"><span>{{'menu.major' | translate}}</span></a>
    </div>

    <div class="nav-item "  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"> 
        <a [routerLink]="['/auth/patient/doctors']"  ngbTooltip="{{'menu.doctors' | translate}}"> <img src="assets/images/doctors-menu.png" class="img-fluid" alt="SEU"><span>{{'menu.doctors' | translate}}</span></a>
    </div>

    <div class="nav-item "  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a [routerLink]="['/auth/patient/appointment']"  ngbTooltip="{{'menu.prevAppointment' | translate}}"><img src="assets/images/appi.png" class="img-fluid" alt="SEU"><span>{{'menu.prevAppointment' | translate}}</span></a>
    </div>

    <div *ngIf="global.Role=='EmployeePatient'" class="nav-item "  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a [routerLink]="['/auth/patient/dependents-view']"  ngbTooltip="{{'dependent.dependents' | translate}}"> <img src="assets/images/employee.png" class="img-fluid" alt="SEU"><span>{{'dependent.dependents' | translate}}</span></a>
    </div>
<!--
    <div class="nav-item ">
        <a [routerLink]="['/auth']"  ngbTooltip="{{'menu.report' | translate}}"><img src="assets/images/report.png" class="img-fluid" alt="SEU"><span>{{'menu.report' | translate}}</span></a>
    </div>
-->
       <!--  <div class="nav-item has-sub ">
            <a href="javascript:void(0)"><i class="ik ik-book"></i><span>{{'Admin.Adminstration' | translate}}</span></a>
            <div class="submenu-content">
              
                      <a  href="#" class="menu-item" [routerLink]="['/admin/user/']" ><i class="ik ik-book-open"></i>{{'Admin.Adduser' | translate}}</a>
                      <a  href="#" class="menu-item" [routerLink]="['/admin/user-view/']" ><i class="ik ik-book-open"></i>{{'Admin.users' | translate}}</a>
                      
            </div>
        </div>
        <div class="nav-item has-sub " >
            <a href="javascript:void(0)"><i class="ik ik-book-open"></i><span>{{'Admin.Basicdata' | translate}}</span></a>
            <div class="submenu-content">
                <a  href="#"  [routerLink]="['/basic-data/program-view']"   class="menu-item" ><i class="ik ik-book-open"></i>{{'Admin.Programs' | translate}}</a>
                <a  href="#"  [routerLink]="['/basic-data/course-view']" class="menu-item" ><i class="ik ik-book-open"></i>{{'Admin.Courses' | translate}}</a>
                <a  href="#"  [routerLink]="['/basic-data/college-view']" class="menu-item" ><i class="ik ik-book-open"></i>{{'Admin.Colleges' | translate}}</a>
                <a  href="#"  [routerLink]="['/basic-data/department-view']" class="menu-item" ><i class="ik ik-book-open"></i>{{'Admin.Departments' | translate}}</a>
                <a  href="#"  [routerLink]="['/basic-data/branch-view']" class="menu-item" ><i class="ik ik-book-open"></i>{{'Admin.Branches' | translate}}</a>
                <a  href="#"  [routerLink]="['/basic-data/crn-view']" class="menu-item" ><i class="ik ik-book-open"></i>{{'Admin.CRNs' | translate}}</a>
                <a  href="#"  [routerLink]="['/basic-data/term-view']" class="menu-item" ><i class="ik ik-book-open"></i>{{'Admin.Terms' | translate}}</a>
             
            </div>
        </div> -->
         
    </nav>
  </div>